export default {
  'portal.renderTemplate.noUrlProvided': 'No template URL provided.',
  'portal.renderTemplate.notFound': 'Template not found.',
  'portal.renderTemplate.renderError': 'We could not render the template.',
  'portal.renderTemplate.renderErrorTrace': 'Error reference:',
};
